var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('a-authorization-card',{staticClass:"ma-5",attrs:{"color":"error","icon":"mdi-shield-alert","title":"Accès interdit","text":"Vous n'avez pas accès à cette page.","sub":"Veuillez contacter l'administrateur du système, si vous pensez que c'est une erreur."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }